import materialQuantities from './materialQuantities'

/**
 * Hoeveel er bij een wijziging van een materiaalregel naar de voorraad terug
 * moet (positief) of eraf moet (negatief): het verschil tussen het
 * voorraadeffect vóór en ná de wijziging.
 *
 * Nodig omdat de handelingen in het materialenscherm dit zelf uitrekenden uit
 * `Quantity`. Dat negeerde `Deducted`: 14 regels uit de oude subtaak-migratie
 * gingen nooit van de voorraad af, maar verwijderen gaf hun aantal toch terug.
 * Het effect van een regel staat op één plek, in materialQuantities.
 * AI-CONTEXT: See docs/features/household-materials.md (Uitbreiding 2026-10)
 *
 * @param {object | null} voor - De regel vóór de wijziging; null bij toevoegen
 * @param {object | null} na - De regel ná de wijziging; null bij verwijderen
 * @returns {number} De delta voor runMaterialStockChange
 */
const materialStockDelta = (voor, na) =>
    (voor ? materialQuantities(voor).stockEffect : 0) - (na ? materialQuantities(na).stockEffect : 0)

export default materialStockDelta
